/**
 * RESPONSIBILITY: draw a band that asks the visitor to do one thing — words and buttons, centred.
 *
 * Deliberately NOT tinted by position: it is the one band meant to stand apart from the
 * page, in the site's deep colour, the way the closing invitation does. It still takes a
 * place in the count, so the bands either side of it alternate as they would.
 */
import { Html } from '@framework/react';
import { BandButtons } from './BandButtons';
import type { BandDef, BandProps } from './kind';

const hasButtons = (b: BandProps['b']) => (b.buttons ?? []).some((x) => x.label && x.href);

function Draw({ b }: BandProps) {
  return (
    <section className="band band-deep band-centre">
      <div className="wrap">
        {b.heading ? <h2>{b.heading}</h2> : null}
        {b.bodyHtml ? <Html className="md-body lede">{b.bodyHtml}</Html> : null}
        <BandButtons b={b} light />
      </div>
    </section>
  );
}

export const cta: BandDef = { has: (b) => !!(b.heading || b.bodyHtml || hasButtons(b)), Draw };
